import NotificationItem from './container';
export default NotificationItem;
